<template>
  <Modal ref="infoModal" title="Informações" @cancel="close">
    <Tabs :options="tabs">
      <div slot="Dados Básicos" class="tab-content dados-basicos-container">
        <div v-if="loading" class="loading">
          <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#1C2D5A'" :size="80" class="mx-2">
          </component>
        </div>

        <template v-else-if="aluno && !loading">
          <div class="photo-container">
            <img :src="`data:image/png;base64,${aluno.foto}`" alt="" class="perfil">

            <Button v-if="role !== 9" @handle:click="updateStudent" text="Atualizar aluno" color="secondary"
              :disabled="loadingActions">
              <Reload :size="18" />
            </Button>
          </div>

          <div class="dados-basicos-infos">
            <div class="inputs-row">
              <Input legend="Nome" :modelValue="aluno.nome" readonly />
              <Input legend="Descrição do processo" :modelValue="aluno.descricao_processo || '-'" readonly />
            </div>
            <div class="inputs-row">
              <Input legend="CPF" :modelValue="utils.formatarCPF(aluno.cpf)" readonly />
              <Input legend="Número de processo" :modelValue="aluno.tipo_processo || '-'" readonly />
            </div>
            <div class="inputs-row">
              <Input legend="Renach" :modelValue="aluno.renach" readonly />
              <Input legend="Início do processo" :modelValue="utils.formatOnlyDate(aluno.inicio_processo)" readonly />
            </div>
          </div>
        </template>
      </div>

      <div slot="Financeiro" class="tab-content financeiro-container">
        <div v-if="loading" class="loading">
          <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#1C2D5A'" :size="80" class="mx-2">
          </component>
        </div>

        <div v-else class="financeiro-content">
          <div class="actions">
            <Button @handle:click="updatePayments" text="Atualizar faturas" color="secondary"
              :disabled="loadingActions">
              <Reload :size="18" />
            </Button>
          </div>

          <template v-if="aluno">
            <h3>Status do aluno</h3>

            <Table :headers="['Prático', 'Teórico']">
              <tr>
                <td v-if="aluno.bloqueio_pratico" class="red">
                  <Close :size="19" /> Bloqueado
                </td>
                <td v-else class="green">
                  <Check :size="19" /> Ativo
                </td>
                <td v-if="aluno.bloqueio_teorico" class="red">
                  <Close :size="19" /> Bloqueado
                </td>
                <td v-else class="green">
                  <Check :size="19" /> Ativo
                </td>
              </tr>
            </Table>
          </template>

          <h3>Faturas</h3>

          <Table :headers="financeiroHeaders">
            <tr v-if="faturas.length < 1">
              <td colspan="7">
                <div class="text-center">
                  Não Possui Faturas
                </div>
              </td>
            </tr>
            <tr v-for="fatura in faturas" :key="fatura.id">
              <td>{{ getFantasyName(fatura.autoescola) }}</td>
              <td>{{ fatura.codigo_processo }}</td>
              <td>{{ fatura.tipoFatura }}</td>
              <td>{{ utils.formatarValor(fatura.valor) }}</td>
              <td>
                <span 
                  v-if="fatura.statusFatura === 'GRATUIDADE CEDIDA' || fatura.statusFatura === 'GRATUIDADE' || fatura.statusFatura === 'GRATUIDADE CEDIDA TEMPORÁRIA'"
                  :title="getTooltipGratuidade(fatura)"
                  class="status-gratuidade"
                  @mouseenter="carregarInfoGratuidade(fatura)"
                  style="cursor: help; border-bottom: 1px dotted #999;"
                >
                  {{ fatura.statusFatura }}
                  <span v-if="carregandoGratuidade[fatura.id]" class="loading-dot">...</span>
                </span>
                <span v-else>{{ fatura.statusFatura }}</span>
              </td>
              <td>{{ fatura.created_at ? utils.formatOnlyDate(fatura.created_at.split(' ')[0]) : '-' }}</td>
              <td>{{ fatura.data_pagamento ? fatura.data_pagamento : '-' }}</td>
              <td>{{ fatura.observacao || '-' }}</td>
              <td v-if="role === 6 || emailsPermitidos.includes(userEmail)">
                <div class="actions">
                  <div v-if="fatura.statusFatura === 'PAGO'">
                    <IconButton @handle:click="() => openReversalModal(fatura)" color="danger" title="Estornar"
                      :disabled="loadingActions">
                      <ArrowLeftBottom :size="19" />
                    </IconButton>
                  </div>

                  <template v-if="Number(fatura.id_status) === 1 || (fatura.id_status) === 7">
                    <div>
                      <IconButton @handle:click="() => openGiveFreeModal('Ceder gratuidade', fatura.id, 'give')"
                        color="success" title="Ceder gratuidade" :disabled="loadingActions">
                        <CashCheck :size="19" />
                      </IconButton>
                    </div>

                    <div>
                      <IconButton
                        @handle:click="() => openGiveFreeModal('Ceder gratuidade temporariamente (24 horas)', fatura.id, 'give', true)"
                        color="success" title="Ceder gratuidade (24 horas)" :disabled="loadingActions">
                        <CashClock :size="19" />
                      </IconButton>
                    </div>
                  </template>

                  <div v-if="Number(fatura.id_status) === 6">
                    <IconButton @handle:click="() => openGiveFreeModal('Remover gratuidade', fatura.id, 'remove')"
                      color="danger" title="Remover gratuidade" :disabled="loadingActions">
                      <CashRemove :size="19" />
                    </IconButton>
                  </div>
                </div>
              </td>
            </tr>
          </Table>
        </div>
      </div>

      <div slot="Histórico" class="tab-content historico-container">
        <div v-if="loading" class="loading">
          <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#1C2D5A'" :size="80" class="mx-2">
          </component>
        </div>

        <template v-else>
          <!-- <div v-if="modal.conteudo.etapa" class="row">
            <div class="col-md-12 text-center">
              <strong class="font-weight-bold">Etapa:</strong><br>
              {{ modal.conteudo.etapa.etapa.titulo }}
            </div>
          </div>
          <br><br>

          <div class="col-md-3">
            <button @click="showData()" id="button" class="btn btn-micro btn-secondary"
              style="margin-left: 20px; margin-top: -70px;"><i class="fa fa-search"></i> Dados</button>
          </div> -->

          <div class="actions">
            <Button @handle:click="downloadPhotos" text="Baixar fotos" color="primary" :disabled="loadingActions">
              <Download :size="18" />
            </Button>
          </div>

          <div>
            <h3>Resumo das Aulas</h3>

            <CargaHorariaTeoricaTable :cargaHoraria="cargaHoraria" />
          </div>

          <div>
            <h3>Aulas de Reposição</h3>

            <Table :headers="['Matéria', 'Turma', 'Status', 'Inicio', 'Fim', 'Presença']">
              <tr v-if="!aulasReposicao.length">
                <td colspan="7" class="text-center">
                  <div class="text-center">
                    Aluno não possui aulas de reposição
                  </div>
                </td>
              </tr>
              <tr v-for="turma in aulasReposicao" :key="turma.id_aula_teorica">
                <td>{{ turma.materia.titulo }}</td>
                <td>{{ turma.agrupamento }}</td>
                <td>{{ turma.status || '-' }}</td>
                <td>{{ utils.formatDate(turma.inicio) }}</td>
                <td>{{ utils.formatDate(turma.fim) }}</td>
                <td v-if="turma.presente">Presente</td>
                <td v-else>Falta</td>
              </tr>
            </Table>
          </div>

          <div>
            <h3>Aulas Teóricas</h3>

            <Table :headers="['Matéria', 'Turma', 'Status', 'Inicio', 'Fim', 'Presença']">
              <tr v-if="!aulasTeoricas.length">
                <td colspan="7">
                  <div class="text-center">
                    Aluno não possui aulas teóricas
                  </div>
                </td>
              </tr>
              <tr v-for="aula in aulasTeoricas" :key="aula.id_aula_teorica">
                <td>{{ aula.materia.titulo }}</td>
                <td>{{ aula.agrupamento }}</td>
                <td>{{ aula.status || '-' }}</td>
                <td>{{ utils.formatDate(aula.inicio) }}</td>
                <td>{{ utils.formatDate(aula.fim) }}</td>
                <td v-if="aula.presente">Presente</td>
                <td v-else>Falta</td>
              </tr>
            </Table>
          </div>

          <div>
            <h3>Aulas Práticas</h3>

            <Table :headers="['Turno', 'Veículo', 'Categoria do veículo', 'Status', 'Data', 'Presença']">
              <tr v-if="!aulasPraticas.length">
                <td colspan="7">
                  <div class="text-center">
                    Aluno não possui aulas práticas
                  </div>
                </td>
              </tr>
              <tr v-for="aula in aulasPraticas" :key="aula.id_aulas_praticas">
                <td>{{ aula.tipo_aula }}</td>
                <td v-if="aula.placa">{{ aula.placa }}</td>
                <td v-else>-</td>
                <td v-if="aula.categoria">{{ aula.categoria }}</td>
                <td v-else>-</td>
                <td>{{ aula.status || '-' }}</td>
                <td>{{ utils.formatDate(aula.data_aula) }}</td>
                <td>
                  <span v-if="aula.id_anotacao_pratica">Presença</span>
                  <span v-else-if="!aula.id_anotacao_pratica && diaDaAulaPassou(aula.data_aula)">Falta</span>
                  <span v-else-if="diaDaAulaNaoRealizada(aula.data_aula)">Não Realizada</span>
                  <span v-else>-</span>
                </td>
              </tr>
            </Table>
          </div>
        </template>
      </div>
    </Tabs>

    <ReversalModal ref="reversalModal" @reversed="updatePayments" />
    <GiveFreeModal ref="giveFreeModal" @updated="detalhes(idAluno, schema)" />
  </Modal>
</template>

<script>
import * as spinners from 'epic-spinners'
import utils from '../../../services/utils'
import Modal from 'core/Modal'
import Tabs from 'core/Tabs'
import Input from 'core/Input'
import Table from 'core/Table'
import Button from 'core/Button'
import IconButton from 'core/IconButton'
import Reload from 'icons/Reload'
import ArrowLeftBottom from 'icons/ArrowLeftBottom'
import Download from 'icons/Download'
import CashRemove from 'icons/CashRemove'
import CashCheck from 'icons/CashCheck'
import Close from 'icons/Close'
import Check from 'icons/Check'
import CashClock from 'icons/CashClock'
import ReversalModal from './ReversalModal'
import GiveFreeModal from './GiveFreeModal'
import CargaHorariaTeoricaTable from '../../teoricas/cargaHorariaTeoricaTable'
import _export from '../../../services/export'

export default {
  name: 'InfoModal',
  components: {
    ...spinners,
    Modal,
    Tabs,
    Input,
    Table,
    Button,
    IconButton,

    Reload,
    ArrowLeftBottom,
    Download,
    CashRemove,
    CashCheck,
    Close,
    Check,
    CashClock,

    ReversalModal,
    GiveFreeModal,
    CargaHorariaTeoricaTable,
  },
  props: {
    autoescolas: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      utils: utils,
      userEmail: localStorage.email,
      role: Number(localStorage.id_role),
      schema: '',
      idAluno: '',
      aluno: null,
      faturas: [],
      cargaHoraria: [],
      aulasReposicao: [],
      aulasTeoricas: [],
      aulasPraticas: [],
      planos: [],
      emailsPermitidos: ['jvdsantos@teste.com', 'nadlo.cavalcante@fabricainfo.com', 'nicole@monitoramento.com', 'joselevi514@gmail.com', 'brenda.tavares@financeiro.com'],
      loading: false,
      loadingActions: false,
      loadingCargaHoraria: false,
      gratuidadeInfo: {}, // Armazena informações das gratuidades por ID da fatura
      carregandoGratuidade: {}, // Controla o estado de carregamento de cada gratuidade
    }
  },
  computed: {
    tabs() {
      if (this.role === 9) {
        return ['Dados Básicos', 'Histórico']
      }

      return ['Dados Básicos', 'Financeiro', 'Histórico']
    },
    financeiroHeaders() {
      if (this.role === 6 || this.emailsPermitidos.includes(this.userEmail)) {
        return ['Autoescola', 'Processo', 'Tipo', 'Valor', 'Status', 'Data Fatura', 'Pagamento', 'Observações', 'Ações']
      }

      return ['Autoescola', 'Processo', 'Tipo', 'Valor', 'Status', 'Data Fatura', 'Pagamento', 'Observações']
    },
  },
  methods: {
    async open(idAluno, schema) {
      await this.detalhes(idAluno, schema)
    },
    async close() {
      this.schema = ''
      this.idAluno = ''
      this.aluno = null
      this.faturas = []
      this.cargaHoraria = []
      this.aulasReposicao = []
      this.aulasTeoricas = []
      this.aulasPraticas = []
      this.planos = []
      this.loading = false
      this.loadingActions = false
      this.loadingCargaHoraria = false

      this.$refs.infoModal.close()
    },
    async detalhes(idAluno, schema) {
      this.loading = true

      this.schema = schema
      this.idAluno = idAluno

      this.$refs.infoModal.open()

      await this.loadCargaHoraria(idAluno)

      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/alunos/consultar/detalhes/${idAluno}`, {
        params: {
          schema,
        }
      })
        .then(res => {
          const dados = res.body.dados

          this.aluno = dados.candidato
          this.faturas = dados.financeiro
          this.aulasReposicao = dados.aulas_reposicao
          this.aulasTeoricas = dados.aulas_regulares
          this.aulasPraticas = dados.aulas_praticas
        })
        .finally(() => {
          this.loading = false
        })
    },
    getFantasyName(schema) {
      const autoescola = this.autoescolas.find(item => item.value === schema)

      return autoescola.text
    },
    async updatePayments() {
      this.loading = true

      for (const fatura of this.faturas) {
        if (fatura.statusFatura == 'PAGO') {
          continue
        }

        await this.$http.post(`${process.env.VUE_APP_URL_API_V2}/faturamento/baixa-individual`, {
          schema: fatura.autoescola,
          fatura: fatura.id
        })
          .then(response => {
            if (response.status == 200) {
              this.$toasted.show(response.data.message, {
                position: 'top-right'
              })
            }
          }).catch(error => {
            this.$toasted.show(error.data.message, {
              position: 'top-right'
            })
          })
      }

      this.$toasted.show('Atualizando os dados . . .', {
        position: 'top-right'
      })

      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/alunos/consultar/detalhes/${this.idAluno}`, {
        params: {
          schema: this.schema,
        }
      })
        .then(res => {
          const dados = res.body.dados
          this.faturas = dados.financeiro
        })
        .finally(() => {
          this.loading = false
        })
    },
    openReversalModal(fatura) {
      this.$refs.reversalModal.open(fatura)
    },
    async loadCargaHoraria(aluno) {
      this.loadingCargaHoraria = true

      const params = {
        aluno,
        schema: this.schema,
      }

      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/aulas/teoricas/alunos/cargahoraria`, {
        params
      })
        .then(response => {
          this.cargaHoraria = response.body.dados
        })
        .catch(err => {
          this.toast('Erro ao buscar carga horária, contate o suporte.')
        })
    },
    diaDaAulaPassou(aula) {
      if (new Date(aula) < new Date()) {
        return true
      }

      return false
    },
    diaDaAulaNaoRealizada(aula) {
      if (new Date(aula) > new Date()) {
        return true
      }

      return false
    },
    async downloadPhotos() {
      this.loadingActions = true

      const params = {
        id: this.aluno.id_aluno,
        schema: this.schema,
      }

      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/alunos/download/fotos`, {
        params,
      })
        .then(res => {
          _export.downloadZIP(res.body.dados, this.aluno.nome)
        })
        .catch(err => {
          this.$toasted.show(err.body.mensagem, {
            position: 'top-right'
          })
        })
        .finally(() => {
          this.loadingActions = false
        })
    },
    async updateStudent() {
      this.loadingActions = true

      this.$toasted.show('Atualizando dados, aguarde...', {
        position: 'top-right',
      })

      const params = {
        schema: this.schema,
        id: this.aluno.id_aluno,
      }

      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/getran/atualizar/aluno`, {
        params,
      })
        .then(res => {
          this.$toasted.show(res.body.mensagem, {
            position: 'top-right',
          })

          this.$emit('updateStudent')

          this.close()
        })
        .catch(err => {
          this.$toasted.show(err.body.mensagem, {
            position: 'top-right',
          })
        })
        .then(() => {
          this.loadingActions = false
        })
    },
    openGiveFreeModal(title, id, status, temporarily = false) {
      this.$refs.giveFreeModal.open(title, this.schema, id, status, temporarily)
    },
    
    /**
     * Carrega informações sobre quem concedeu a gratuidade
     */
    async carregarInfoGratuidade(fatura) {
      // Se já temos a informação em cache, não precisa carregar novamente
      if (this.gratuidadeInfo[fatura.id]) {
        return
      }
      
      // Marca como carregando
      this.$set(this.carregandoGratuidade, fatura.id, true)
      
      try {
        const response = await this.$http.post(`${process.env.VUE_APP_URL_API_V2}/faturamento/gratuidade/info`, {
          faturaId: fatura.id,
          schema: fatura.autoescola
        })
        
        if (response.data.sucesso) {
          // Armazena no cache local
          this.$set(this.gratuidadeInfo, fatura.id, response.data.dados)
        } else {
          // Se não encontrou, coloca informação padrão
          this.$set(this.gratuidadeInfo, fatura.id, {
            usuario: 'Sistema',
            data: 'Data não disponível'
          })
        }
      } catch (error) {
        console.warn('Erro ao carregar informações de gratuidade:', error)
        // Em caso de erro, coloca informação padrão
        this.$set(this.gratuidadeInfo, fatura.id, {
          usuario: 'Sistema',
          data: 'Data não disponível'
        })
      } finally {
        // Remove o estado de carregando
        this.$set(this.carregandoGratuidade, fatura.id, false)
      }
    },
    
    /**
     * Retorna o texto do tooltip para faturas com gratuidade
     */
    getTooltipGratuidade(fatura) {
      const info = this.gratuidadeInfo[fatura.id]
      if (info) {
        // Verifica se é um registro sem dados de auditoria
        if (info.sem_dados_auditoria) {
          return info.observacao || 'Dados de gratuidade não disponíveis para este registro anterior à implementação do sistema de auditoria.'
        }
        
        // Formato padrão para registros com dados de auditoria completos
        if (info.usuario && info.data) {
          let tooltip = `Gratuidade cedida por: ${info.usuario} em ${info.data}`
          if (info.tipo) {
            tooltip += ` (${info.tipo})`
          }
          if (info.observacao && info.observacao !== 'Gratuidade permanente concedida') {
            tooltip += `\nObservação: ${info.observacao}`
          }
          return tooltip
        }
        
        // Fallback para dados incompletos
        return info.observacao || 'Dados de gratuidade não disponíveis para este registro anterior à implementação do sistema de auditoria.'
      }
      
      return this.carregandoGratuidade[fatura.id] ? 'Carregando informações...' : 'Dados de gratuidade não disponíveis para este registro anterior à implementação do sistema de auditoria.'
    },
  },
}
</script>

<style lang="scss" scoped>
.tab-content {
  width: 75vw;

  .loading {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  h3 {
    text-align: center;
    margin: 0;
    font-family: Nunito Sans;
    font-size: 1.25rem;
    font-weight: 700;
    color: #000000;
  }
}

.dados-basicos-container {
  display: flex;
  flex-wrap: wrap;
  gap: 3rem;

  .photo-container {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    .perfil {
      width: 13.25rem;
      border-radius: 10px;
      /* height: 18.5rem; */
      object-fit: contain;
    }
  }

  .dados-basicos-infos {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 2.5rem;

    .actions {
      display: flex;
      justify-content: flex-end;
    }

    .inputs-row {
      display: flex;
      align-items: center;
      gap: 1.5rem;

      >div {
        flex: 1;
      }
    }
  }
}

.financeiro-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  .financeiro-content {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;

    .actions {
      display: flex;
      align-items: center;

      div {
        padding: 0 0.5rem;
        display: flex;
        justify-content: center;

        &:not(:first-child) {
          border-left: 1px solid #ECECEC;
        }

        &:not(:last-child) {
          border-right: 1px solid #ECECEC;
        }
      }
    }

    .green {
      color: #007B19;
    }

    .red {
      color: #CF0206;
    }
  }
}

.historico-container {
  display: flex;
  flex-direction: column;
  gap: 3.5rem;

  >div {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  .actions {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
}

.presencas-container {
  width: 50vw;
  display: flex;
  flex-direction: column;
  gap: 2.0625rem;

  .presencas-table {
    tr {
      border: none;
    }

    .presencas-table-header {
      >th {
        padding: 0.5rem 0.5rem 2rem;
        font-size: 1rem;
        font-weight: 700;
        text-align: center;
        color: #1C2D5A;
      }
    }

    .presencas-table-content {
      >td {
        font-size: 1rem;
        font-weight: 700;
        text-align: center;
        color: #1C2D5A;

        &.red {
          color: #E91D23;
        }
      }

      img {
        width: 10.5rem;
        height: 10.5625rem;
        border-radius: 5.74px;
        border: 0.57px solid #A8A8A8;
        object-fit: contain;
      }
    }
  }

  .presencas-photos-container {
    display: flex;
    flex-direction: column;
    gap: 2.0625rem;

    h3 {
      margin: 0;
      display: flex;
      flex-direction: column;
      font-size: 1.5rem;
      font-weight: 700;
      text-align: left;
      color: #202224;
    }

    .photos {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 2.0625rem;

      >img {
        width: 5.375rem;
        height: 5.375rem;
        border-radius: 2.93px;
        border: 0.29px solid #A8A8A8;
      }
    }
  }
}

// Estilos para tooltip de gratuidade
.status-gratuidade {
  cursor: help;
  text-decoration: underline;
  text-decoration-style: dotted;
  color: #1C2D5A;
  position: relative;
  
  &:hover {
    color: #0F1C3A;
    text-decoration-style: solid;
  }
  
  .loading-dot {
    display: inline-block;
    animation: loading-dots 1.5s infinite;
    margin-left: 3px;
  }
}

@keyframes loading-dots {
  0%, 20% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  80%, 100% {
    opacity: 0;
  }
}
</style>
